import LinesHighlightComponent from "ags/components/lines-highlight-component";
import WaysHighlightComponent from "ags/components/ways-highlight-component";
import FreespinScatterResult from "ags/integration/builders/results/freespin-scatter-result";
import LoopWinsMediator from "ags/mediators/loop-wins-mediator";
import SymbolComponent from "slotworks/components/matrix/symbol/symbol-component";
import LineResult from "slotworks/model/gameplay/records/results/line-result";
import WaysResult from "slotworks/model/gameplay/records/results/ways-result";
import Contract from "slotworks/utils/contracts/contract";
import Parallel from "slotworks/utils/contracts/parallel";

export default class BigBorderLoopWinsMediator extends LoopWinsMediator {

    protected activeBorder: WaysHighlightComponent;

    public end(): Contract<void> {
        return new Parallel([
            () => super.end(),
            () => Contract.wrap(() => {
                if (this.activeBorder) {
                    this.activeBorder.destroy();
                }
            })
        ]);
    }

    protected showCelebrationForSymbols(symbols: SymbolComponent[]) {
        return this.getHighlightForWin(symbols).show();
    }

    protected getHighlightForWin(symbols: SymbolComponent[]) {

        const win = this.wins[this.currentWin];

        if (win instanceof WaysResult || win instanceof FreespinScatterResult) {
            this.activeBorder = new WaysHighlightComponent(symbols, win);
        } else if (win instanceof LineResult) {
            this.activeBorder = new LinesHighlightComponent(symbols, win);
        } else {
            throw new Error("The Big Border Loop Wins Mediator demands a Ways or Line Result. Neither was recieved.");
        }

        return this.activeBorder;
    }
}
